module.exports = __webpack_public_path__ + "static/media/avatar.1eb8d8fb.png";